"use strict";
/*
 * Created on 02 08 2021
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var OptimizationScenarioData_1 = require("../model/OptimizationScenarioData");

var OptimalMarginGraphDataConverter_1 = require("./OptimalMarginGraphDataConverter");

var OptimizationScenarioDataConverter_1 = require("./OptimizationScenarioDataConverter");

var StrategyGraphDataConverter_1 = require("./StrategyGraphDataConverter");
/**
 * @author Jaroslav Sevcik
 */


var OptimizationScenarioDataConverterImpl =
/*#__PURE__*/
function (_OptimizationScenario) {
  _inherits(OptimizationScenarioDataConverterImpl, _OptimizationScenario);

  function OptimizationScenarioDataConverterImpl(strategyGraphDataConverter, optimalMarginGraphDataConverter) {
    var _this;

    _classCallCheck(this, OptimizationScenarioDataConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(OptimizationScenarioDataConverterImpl).call(this));
    _this.strategyGraphDataConverter = strategyGraphDataConverter;
    _this.optimalMarginGraphDataConverter = optimalMarginGraphDataConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(OptimizationScenarioDataConverterImpl, [{
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this2 = this;

      if (typeof source !== 'object' || source === null) {
        return null;
      }

      return {
        points: conversions.asObjectArray(source, 'points', function (v) {
          return _this2.strategyGraphDataConverter.toDocument(v, conversions);
        }),
        actualData: source.actualData && this.strategyGraphDataConverter.toDocument(source.actualData, conversions),
        optimalMargins: conversions.asObjectArray(source, 'optimalMargins', function (v) {
          return _this2.optimalMarginGraphDataConverter.toDocument(v, conversions);
        })
      };
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this3 = this;

      return new OptimizationScenarioData_1.OptimizationScenarioData(conversions.asObjectList(source, 'points', function (v) {
        return _this3.strategyGraphDataConverter.toObject(v, conversions);
      }), conversions.asObjectOpt(source, 'actualData', function (v) {
        return _this3.strategyGraphDataConverter.toObject(v, conversions);
      }), conversions.asObjectList(source, 'optimalMargins', function (v) {
        return _this3.optimalMarginGraphDataConverter.toObject(v, conversions);
      }));
    }
  }]);

  return OptimizationScenarioDataConverterImpl;
}(OptimizationScenarioDataConverter_1.OptimizationScenarioDataConverter);

OptimizationScenarioDataConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __param(1, typescript_ioc_1.Inject), __metadata("design:paramtypes", [StrategyGraphDataConverter_1.StrategyGraphDataConverter, OptimalMarginGraphDataConverter_1.OptimalMarginGraphDataConverter])], OptimizationScenarioDataConverterImpl);
exports.OptimizationScenarioDataConverterImpl = OptimizationScenarioDataConverterImpl;